import React from 'react';
import withState from '../../../../../../../../utils/withState';
import {apiTerminalsList} from "../../../../../../../../api/merchant/terminals";
import {paramStore} from "../../../../../../../../stores";
import Ripple from "../../../../../../../dumb/Ripple";
import {DisplayDataMerchant} from "../../../../../../../dumb/DisplayData";
import editTerminalName from "../../utils/editTerminalName";
import {MerchantSelect} from "../../../../../../../helpers/InputsHelpers";
import TerminalsTrxTable from "../../../TerminalsTrxTable";
import PasswordDisplay from "./components/PasswordDisplay";
import {Box} from "@material-ui/core";

export default withState((setState, self, onMount) => {
  const id$ = paramStore('id');

  const update = () => {
    const id = id$.getValue();

    return apiTerminalsList({offset: 0, limit: 100}).then((result) => {
      const data = (result || {}).list.find((el) => el.id === id);

      setState({data, loading: false});
    });
  }

  onMount(() => {
    setState({loading: true});
    update();
  })

  return (state) => {
    const data = state.data || {};

    return !state.loading
      ? (
        <>
          <div className="layoutRow jcSB">
            <div className="layoutRow aiC">
              <Ripple
                onClick={() => id$.emit('')}
              >
                <svg className="dB" width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1.875L7.1658 -1.60351e-07L2.98003e-07 7.5L7.1658 15L9 13.125L3.6 7.5L9 1.875Z" fill="black"/>
                </svg>
              </Ripple>
              <div className="wmax100vw-620 ml20 f23 fw7">
                <DisplayDataMerchant>
                  {data.name || data.device_name}
                </DisplayDataMerchant>
              </div>
              <Ripple
                className="ml26"
                onClick={() => editTerminalName(data, update)}
              >
                <svg className="dB" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12.8624 0.213733C13.1474 -0.0712443 13.6094 -0.0712443 13.8944 0.213733L17.7863 4.10562C18.0712 4.3906 18.0712 4.85264 17.7863 5.13762L5.13762 17.7863C5.00077 17.9231 4.81516 18 4.62162 18H0.72973C0.326711 18 0 17.6733 0 17.2703V13.3784C0 13.1848 0.076882 12.9992 0.213733 12.8624L12.8624 0.213733ZM11.4915 3.64865L14.3514 6.50855L16.2383 4.62162L13.3784 1.76172L11.4915 3.64865ZM13.3194 7.54054L10.4595 4.68064L1.45946 13.6806V16.5405H4.31936L13.3194 7.54054ZM7.78378 17.2703C7.78378 16.8673 8.1105 16.5405 8.51351 16.5405H16.7838C17.1868 16.5405 17.5135 16.8673 17.5135 17.2703C17.5135 17.6733 17.1868 18 16.7838 18H8.51351C8.1105 18 7.78378 17.6733 7.78378 17.2703Z" fill="#A3A7AC"/>
                </svg>
              </Ripple>
              {/*<div className="ml26">*/}
              {/*  <MerchantSelect*/}
              {/*    propName="name"*/}
              {/*    propValue="id"*/}
              {/*    items={[*/}
              {/*      {id: 'active', name: 'active'},*/}
              {/*      {id: 'inactive', name: 'inactive'}*/}
              {/*    ]}*/}
              {/*    value="active"*/}
              {/*  />*/}
              {/*</div>*/}
            </div>
            {!!data.password && (
              <Box display="flex" alignItems="center">
                <span>Passcode</span>
                <Box ml="2rem">
                  <PasswordDisplay
                    className="ml20"
                    value={data.password || ''}
                  />
                </Box>
              </Box>
            )}
          </div>
          <Box width="100%" height="calc(100vh - 250px)" minHeight="500px">
            <TerminalsTrxTable terminalId={id$.getValue()} />
          </Box>
        </>
      ) : (
        <span />
      )
  }
})
